import styles from './Loader.module.css';

import { Spinner } from '@phosphor-icons/react';

import { Image } from '../themed/Image';

export const Loader = () => (
  <div className={styles.container}>
    <Image icon={<Spinner size={88} color="white" className={styles.loader} />} />
  </div>
);
